$(document).ready(function () {
  var focusOffsetDefaultConstant = 85;
  $.fn.validator.Constructor.FOCUS_OFFSET = focusOffsetDefaultConstant;
  $.fn.validator.Constructor.INPUT_SELECTOR += ",.multi-field-add,textarea";

  var generateFileUploadInputHTML = function generateFileUploadInputHTML() {
    return '<input data-file-id="' + window.uuidv4() + '" class="file file-empty" type="file" name="file" />';
  };

  var generateFileItemHTML = function generateFileItemHTML(fileName, fileId) {
    return '<li class="list-group-item clearfix" new-data-file-id="' + fileId + '">' + '<div class="file-name">' + '<span class="glyphicon glyphicon glyphicon-file" aria-hidden="true"></span>' + fileName + "</div>" + '<span class="pull-right">' + '<button type="button" class="btn btn-danger">' + "Ta bort" + "</button>" + "</span>" + "</li>";
  };

  $(".ethics-form").each(function () {
    var ethicsForm = $(this);
    ethicsForm.validator({
      custom: {
        "min-added": function minAdded($el) {
          var minAmount = $el.attr("data-min-added");
          var multiFieldAdd = $el.data("MultiFieldAdd");
          var amountFound = multiFieldAdd.val();
          return amountFound < minAmount && "Not enough items added";
        },
        "date-not-before": function dateNotBefore($el) {
          var notBeforeDatePickerSelector = $el.attr("data-date-not-before");
          var notBeforeDate = $('#' + notBeforeDatePickerSelector);
          return notBeforeDate.val() > $el.val() && "End date can not be earlier than start date";
        },
        "ckeditor-minlength": function ckeditorMinlength($el) {
          var length = $el.attr("data-ckeditor-minlength");
          var text = $($el.ckeditor().editor.getData()).text();
          return text.length < length && "Length is to short";
        },
        "amount-numeric": function amountNumeric($el) {
          var pattern = /[^0-9]/;
          var text = $('#Amount').val();
          var found = pattern.test(text);
          return found && "amount has to be numeric";
        }
      }
    });
    ethicsForm.dirtyForms();
    var draftForms = $('*[data-accept-draft="true"]');

    if (draftForms.length > 0) {
      /**
          Change to draft-mode on validation when SaveAsDraft is chosen
      **/
      draftForms.find('button[type="submit"]').on("click", function (e) {
        e.preventDefault();
        var submitButton = $(this);
        var isDraft = submitButton.val() === "SaveAsDraft" ? true : false;

        if (!isDraft) {
          $('form').attr('action', 'Save');
          return;
        }

        $('form').attr('action', 'SaveAsDraft');
        var fields = ethicsForm.find($.fn.validator.Constructor.INPUT_SELECTOR);
        fields.each(function (i, element) {
          var self = $(element);
          self.attr("data-validate", isDraft && self.attr("data-draft-validate") === "true");
        });
        ethicsForm.validator("update");
      });
      $(draftForms).on("click", "a.btn-multi-toggle", function (e) {
        e.preventDefault();
        var constValueAttribute = "data-value";
        var aLinkToCopyFrom = $(this);
        var buttonElementToCopyTo = $(aLinkToCopyFrom.attr("data-toggle-with"));
        var tempValue = buttonElementToCopyTo.val();
        var tempText = buttonElementToCopyTo.html();
        buttonElementToCopyTo.val(aLinkToCopyFrom.attr(constValueAttribute));
        buttonElementToCopyTo.html(aLinkToCopyFrom.html());
        aLinkToCopyFrom.attr(constValueAttribute, tempValue);
        aLinkToCopyFrom.html(tempText);
        buttonElementToCopyTo.trigger("click");
      });
    }
    /**
        Add file clicked. 
    **/


    $(".upload-file-form").on("click", function () {
      var newFilesContainer = $(".files-new");
      var currentFile = newFilesContainer.find(".file.file-empty");

      if (currentFile.length === 0) {
        currentFile = $(generateFileUploadInputHTML());
        newFilesContainer.append(currentFile);
      }

      currentFile.trigger("click");
    });
    /**
        File selected by file picker
    **/

    $(".files-new").on("change", "input", function () {
      var currentFile = $(this);
      currentFile.removeClass("file-empty");
      var fileName = currentFile.val().split("\\").pop();
      var fileId = currentFile.attr("data-file-id");
      $(".files-list").append($(generateFileItemHTML(fileName, fileId)));
      ethicsForm.validator("validate");
    });
    /**
        Remove file button clicked
    **/

    $(".files-list").on("click", "button", function () {
      var shouldRemove = window.confirm("Är du säker på att du vill ta bort detta dokument?");

      if (shouldRemove) {
        var clickedItem = $(this);
        var liNode = clickedItem.closest("li");
        var newId = liNode.attr("new-data-file-id");
        var oldId = liNode.attr("old-data-file-id");

        if (newId) {
          var inputNode = $('.files-new input[data-file-id="' + newId + '"');
          inputNode.remove();
          liNode.remove();
        } else if (oldId) {
          liNode.find(".deleted-input").val(true);
          liNode.addClass("file-deleted");
        }

        ethicsForm.validator("validate");
      }
    });
    $(".suggestion-autocomplete").each(function () {
      var self = $(this);
      var values = self.data("suggestion-values");
      $(".btn-save-add-new").hide();
      $(".btn-cancel-add-new").hide();

      if (values) {
        self.attr("autocomplete", "off");
        self.autocomplete({
          lookup: values,
          minChars: 0,
          onInvalidateSelection: function onInvalidateSelection() {
            self.val("");
          },
          onSelect: function onSelect(suggestion) {
            self.trigger("input");
          }
        });
      }
    });
    $(".btn-add-new").on("click", function () {
      $(this).closest("form").find("#Name").hide();
      $(this).closest("form").find("#Name").after('<input id="Name" name="Name" class="form-control add-new" type="text" placeholder="Namn på företaget" />');
      $(".btn-add-new").hide();
      $(".btn-save-add-new").show();
      $(".btn-cancel-add-new").show();
    });
    $(document).on("blur", ".add-new", function () {
      $(this).closest("form").find("#Name").val($(this).val());
    });
    $(".btn-save-add-new").on("click", function () {
      resetAutocompleteField();
      $(this).closest("form").find("#Name").show();
    });
    $(".btn-cancel-add-new").on("click", function () {
      resetAutocompleteField();
      $(this).closest("form").find("#Name").show();
    });
    $(".add-area.modal").on("hidden.bs.modal", function () {
      resetAutocompleteField();
      $(this).find("#Name").show();
    });

    function resetAutocompleteField() {
      $(".add-new").remove();
      $(".btn-save-add-new").hide();
      $(".btn-cancel-add-new").hide();
      $(".btn-add-new").show();
    } // Multi Field Add Component


    var MultiFieldAdd = function MultiFieldAdd(element) {
      this.$el = $(element);
    };

    MultiFieldAdd.prototype = {
      val: function val() {
        return this.$el.find("tbody tr").length;
      }
    }; // End Multi Field Add Component

    $.valHooks.fieldset = {
      get: function get(elem) {
        var self = $(elem);

        if (self.hasClass('multi-field-add')) {
          return self.data('MultiFieldAdd').val();
        }

        return '';
      }
    };
    $(".multi-field-add").each(function (i, itm) {
      var multiFieldAddMainElement = $(itm);
      var multiFieldAdd = new MultiFieldAdd(itm);
      multiFieldAddMainElement.data("MultiFieldAdd", multiFieldAdd);
      var resultAreaTableBody = $(".result-area tbody", multiFieldAddMainElement);
      var prefix = multiFieldAddMainElement.attr("data-name-prefix");
      var addButton = $("button.btn-add", multiFieldAddMainElement);
      var addModal = $(addButton.attr("data-target"));

      if (addModal === undefined) {
        throw "Could not find add modal";
      }

      var inputs = $("input[type!=button][type!=submit]", addModal);
      var addUpdateModalForm = $("form", addModal);
      var addOrUpdateButtonInModal = $("button.btn-add-or-update", addModal);

      var revalidateMultiFieldAdd = function revalidateMultiFieldAdd() {
        multiFieldAddMainElement.trigger("input");
      };

      addButton.on("click", function (e) {
        e.preventDefault();
        addOrUpdateButtonInModal.html($(this).html());
      });
      multiFieldAddMainElement.on("click", ".result-area tr button.edit", function (e) {
        e.preventDefault();
        var buttonElement = $(this);
        var tableRowElement = buttonElement.closest("tr");
        addOrUpdateButtonInModal.html(buttonElement.html());
        addModal.data("edit-item", tableRowElement);
        inputs.each(function (j, inp) {
          var suffix = $(inp).attr("name").split(".").slice(-1)[0];
          var tempInput = tableRowElement.find("input[name$='." + suffix + "']").val();
          $('input[name="' + suffix + '"]', addModal).val(tempInput);
        });
      });
      resultAreaTableBody.on("click", "tr button.delete", function (e) {
        e.preventDefault();
        var confirmDeleteButton = confirm(multiFieldAddMainElement.attr("data-delete-confirmation-text") || "Är du säker på att du vill ta bort?");

        if (confirmDeleteButton === true) {
          $(this).closest("tr").remove();
        } else {
          return;
        }

        addModal.data("edit-item", null);
        $("tr", resultAreaTableBody).each(function (trIndex, el) {
          var tableRowElement = $(el);
          var oldIndex = tableRowElement.attr("data-index");
          $("input", this).each(function (inputIndex, inputElement) {
            var self = $(inputElement);
            var inputName = self.attr("name");
            inputName = inputName.replace(prefix + "[" + oldIndex + "]", prefix + "[" + trIndex + "]");
            self.attr("name", inputName);
          });
          tableRowElement.attr("data-index", trIndex);
        });
        revalidateMultiFieldAdd();
      });
      addModal.on("hidden.bs.modal", function () {
        revalidateMultiFieldAdd();
        addModal.data("edit-item", null);
        addUpdateModalForm.trigger("reset");
      });
      addUpdateModalForm.on("submit", function (e) {
        var self = $(this); // WARNING: This is a "hacky" way of validating the subform
        // as the validator does not have a function that returns
        // if it's valid or not.
        // Prerequisite: The feature disable of submit-button need
        // to be enabled

        addUpdateModalForm.validator("validate");

        if (addOrUpdateButtonInModal.hasClass("disabled")) {
          return;
        } // Check if its an update or new post


        var tableRowElement = addModal.data("edit-item");

        if (tableRowElement) {
          inputs.each(function (j, el) {
            var imp = $(el);
            var tempInput = imp.val();
            var updateInfoPath = $('input[name$=".' + imp.attr("name") + '"]', tableRowElement);
            updateInfoPath.val(tempInput);
            $(".display-" + imp.attr("name"), tableRowElement).html(imp.val());
          });
          addModal.data("edit-item", null);
        } else {
          var lastRowDataIndexValue = $("tr", resultAreaTableBody).last().attr("data-index");
          var lastDataIndexId = 0;

          if (lastRowDataIndexValue) {
            lastDataIndexId = parseInt(lastRowDataIndexValue) + 1;
          }

          var liElm = $('<tr data-index="' + lastDataIndexId + '"></tr>');
          var displayItems = "";
          var inputItems = "";
          inputs.each(function (j, el) {
            var inp = $(el);
            inputItems += "<input type='hidden' name='" + prefix + "[" + lastDataIndexId + "]." + inp.attr("name") + "' value='" + inp.val() + "' />";
            displayItems += "<td class='display-" + inp.attr("name") + "'>" + inp.val() + "</td>";
          });
          var buttons = $(displayItems + '<td><button type="button" class="edit btn btn-primary" data-toggle="modal" data-target="' + addButton.attr("data-target") + '">Ändra</button></td>' + '<td><button type="button" class="delete btn btn-danger">Ta bort</button>' + inputItems + "</td>").appendTo(liElm);
          $(buttons).appendTo(liElm);
          resultAreaTableBody.append(liElm);
        }

        revalidateMultiFieldAdd();
        $(addModal.find("form")).trigger("reset");
        addModal.data("edit-item", null);
        addModal.modal("hide");
      });
    });
    ethicsForm.on("click", 'button[type="submit"]', function (e) {
      e.preventDefault();
      var self = $(this);
      ethicsForm.validator("validate"); // WARNING: This is a "hacky" way of validating the subform
      // as the validator does not have a function that returns
      // if it's valid or not.
      // Prerequisite: The feature disable of submit-button need
      // to be enabled

      if (self.hasClass("disabled")) {
        return false;
      }

      ethicsForm.submit();
    });
    ethicsForm.on("click", "a.btn-href-with-confirm, button.btn-href-with-confirm", function (e) {
      e.preventDefault();
      var self = $(this);
      var confirmCancelButton = confirm(self.attr("data-confirmation-text") || "Är du säker?");

      if (confirmCancelButton === true) {
        window.location.href = self.attr("data-href") || self.attr("href");
      }
    });
    $("input[type=checkbox]", ".patients-or-relatives").change(function () {
      var thisCheckbox = $(this);
      var container = $(thisCheckbox.closest(".economics"));
      var checkboxContainer = $(thisCheckbox.closest("div.checkbox"));
      var resultElement = container.find(".lead");
      var displayItems = container.data("checked-items") || [];
      var checkboxName = $(checkboxContainer.find("span.value")).text();

      if (thisCheckbox.prop("checked")) {
        displayItems.push(checkboxName);
      } else {
        displayItems.splice($.inArray(checkboxName, displayItems), 1);
      }

      var outputString = displayItems.join(", ");

      if (displayItems.length <= 0) {
        resultElement.val("Ingen ersättning");
      } else {
        resultElement.val(outputString);
      }

      container.data("checked-items", displayItems);
    });
    var dateTimePickerSettings = {
      locale: "sv",
      format: "YYYY-MM-DD",
      minDate: 1,
      allowInputToggle: true
    };
    $(".ethics-form .datetimepicker-max").each(function () {
      var self = $(this);
      var dateTimePickerSettingsWithoutCurrent = $.extend({}, dateTimePickerSettings, {
        useCurrent: false
      });
      var pickerMinSelector = self.attr("data-date-later-than");
      var pickerMinInputEl = $("#" + pickerMinSelector);
      var pickerMinEl = pickerMinInputEl.parent('.input-group');

      if (!pickerMinEl && pickerMinEl.length == 0) {
        throw "Could not find datepicker for data-date-later-than";
      }

      var pickerMax = self.datetimepicker(dateTimePickerSettingsWithoutCurrent);
      var pickerMin = pickerMinEl.datetimepicker(dateTimePickerSettings);
      pickerMin.on("dp.change", function (e) {
        pickerMax.data("DateTimePicker").minDate(e.date);
      });
    }); // **** Ckeditor ****

    $(".ck-editor", ethicsForm).each(function (i, el) {
      var self = $(el);
      var required = self.attr('required');
      var editor = self.ckeditor({
        toolbarGroups: [{
          name: 'clipboard',
          groups: ['clipboard', 'undo']
        }, {
          name: 'editing',
          groups: ['find', 'selection', 'spellchecker']
        }, {
          name: 'links'
        }, {
          name: 'insert'
        }, {
          name: 'forms'
        }, {
          name: 'tools'
        }, {
          name: 'document',
          groups: ['mode', 'document', 'doctools']
        }, {
          name: 'others'
        }, '/', {
          name: 'basicstyles',
          groups: ['basicstyles', 'cleanup']
        }, {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi']
        }, {
          name: 'styles'
        }, {
          name: 'colors'
        }, {
          name: 'about'
        }]
      }).editor;

      if (required) {
        self.attr('required', 'true');
      }

      editor.on('change', function (evt) {
        evt.editor.updateElement();
        setTimeout(function () {
          self.change();
        }, 200);
      });
    }); // Delete activity

    $("#other-reason-delete, #project-closed-delete").change(function () {
      var deleteReasonText = $("#DeletedReasonOtherThanClosed").val();
      var otherReasonChecked = $("#other-reason-delete").prop('checked');
      var projectClosedReasonChecked = $("#project-closed-delete").prop('checked');

      if (otherReasonChecked) {
        $("#DeletedReasonOtherThanClosed").prop('disabled', false);
      } else {
        $("#DeletedReasonOtherThanClosed").prop('disabled', true);
        $("#DeletedReasonOtherThanClosed").val("");
      }

      if (deleteReasonText.length > 5 && otherReasonChecked) {
        $("#DeleteActivityButton").prop('disabled', false);
      } else if (projectClosedReasonChecked) {
        $("#DeleteActivityButton").prop('disabled', false);
      } else {
        $("#DeleteActivityButton").prop('disabled', true);
      }
    });
    $("#DeletedReasonOtherThanClosed").on("change mouseout", function () {
      var deleteReasonText = $("#DeletedReasonOtherThanClosed").val();
      var otherReasonChecked = $("#other-reason-delete").prop('checked');

      if (deleteReasonText.length > 5 && otherReasonChecked) {
        $("#DeleteActivityButton").prop('disabled', false);
      } else if (otherReasonChecked) {
        $("#DeleteActivityButton").prop('disabled', true);
      }
    });
    $("#CancelDeleteActivity").on("click", function () {
      $("#DeletedReasonOtherThanClosed").val("");
      $("#other-reason-delete").prop('checked', false).trigger("click");
      $("#project-closed-delete").prop('checked', false).trigger("click");
    });
    $("#DeleteActivityButton").on("click", function () {
      $("#deleteSpinner").html('<div id="deleteSpinner" class="lds-spinner" disabled="true"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>');
    });
  });
});